import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clients-feedback-testimonials',
  templateUrl: './clients-feedback-testimonials.component.html',
  styleUrls: ['./clients-feedback-testimonials.component.css']
})
export class ClientsFeedbackTestimonialsComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/clients-feedback-testimonials/clients-feedback-testimonials.component.ts